import React, { useCallback, useState } from 'react'
import classNames from 'classnames'
import { AmountFieldOuterProps, FieldChildren } from './types'
import { ErrorMessage } from '../error_message'
import { Field, connect } from 'formik'
import { FormValues } from 'donate/types'
import { parseCents, sanitizeMoney } from '@betterplace/utils'

export const AmountField: React.ComponentType<AmountFieldOuterProps> = connect<AmountFieldOuterProps, FormValues>(
  ({
    formik: {
      setFieldValue,
      setFieldTouched,
      values: { amount_cents },
      initialValues: { amount_cents: initialCents },
    },
    hideError = false,
  }) => {
    const [value, setValue] = useState(`${initialCents / 100}`)

    const onChanged: React.ChangeEventHandler<HTMLInputElement> = useCallback(
      (event) => {
        void setFieldValue('amount_cents', parseCents(event.target.value))
        setValue(sanitizeMoney(event.target.value))
      },
      [setFieldValue]
    )
    const onBlurred: React.ChangeEventHandler<HTMLInputElement> = useCallback(() => {
      setFieldTouched('amount_cents', true)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialCents, amount_cents, setFieldTouched])

    return (
      <Field name="amount_cents">
        {
          (({ field: { onChange: _onChange, value: _value, ...fieldProps }, form }) => (
            <>
              <input
                className={classNames('form-control', { 'field-with-error': form.errors.amount_cents })}
                size={8}
                type="text"
                inputMode="decimal"
                value={value}
                {...fieldProps}
                onChange={onChanged}
                onBlur={onBlurred}
              />
              <span className="input-currency-symbol">€</span>
              {!hideError && <ErrorMessage field="amount_cents" />}
            </>
          )) as FieldChildren
        }
      </Field>
    )
  }
)
